import compose from 'recompose/compose';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import CountryEntranceType from './CountryEntranceType';

export default compose(
  connect(
    (state) => ({
      data: _get(state, 'customers.customerDetail.data.countryEntrance', {}),
      listOfInvalidsDocuments: _get(
        state,
        'customers.customerDetail.data.listOfInvalidsDocuments',
        []
      ),
    }),
    {}
  )
)(CountryEntranceType);
